export default __webpack_public_path__ + "static/15_9-9e89d2ce592868f3be0c474e6eaefb29.png";